import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { tabItems, type NavRoles } from './navItems';
import { NavIcon } from './NavIcon';

// min-h-tap keeps every tab at the 44px floor; flex-1 across four slots is
// ~93px wide at 375px, so the horizontal half of the hit area is covered too.
const ITEM = 'flex-1 min-h-tap flex flex-col items-center justify-center gap-0.5 text-[11px] font-medium';

export function TabBar({ roles, onMoreClick }: { roles: NavRoles; onMoreClick: () => void }) {
  return (
    <nav
      data-testid="tab-bar"
      aria-label="Primary"
      // pl-safe-l/pr-safe-r (env(safe-area-inset-left/right)) alongside the
      // existing pb-safe-b: in landscape on a notched phone the bar spans
      // the full width, so its outer items need the same inset padding
      // horizontally that pb-safe-b already gives it vertically, or they
      // sit under the notch/rounded corner instead of being reachable.
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 flex border-t border-border-token bg-surface pb-safe-b pl-safe-l pr-safe-r"
    >
      {tabItems(roles).map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            clsx(ITEM, isActive ? 'text-accent' : 'text-content-muted')
          }
        >
          <NavIcon name={item.icon} className="w-6 h-6" />
          {item.label}
        </NavLink>
      ))}
      <button type="button" onClick={onMoreClick} className={clsx(ITEM, 'text-content-muted')}>
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h.01M12 12h.01M19 12h.01" />
        </svg>
        More
      </button>
    </nav>
  );
}
